
export default {
  data: () => ({

    rawData:  [],
    
    title: null,
    schedule: null,
    chart: null,
    header: null,
    table: null,
    columns: null,
    
    keys: null,
    filters: null,

    canvasForms:  null,

    funcY: 0,

  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}